<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors, socials } from '@utils/form'
import { httpServices } from '@utils/http-services'

let id = 0

export default {
  page: {
    title: 'Create Figment',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      containers: [],
      availableContainers: [],
      image: '',
      imageType: '',
      uploadURL: '',
      users: [],
      groups: [],
      groupId: null,
      orgs: [],
      sims: [],
      socials: socials,
      formLayout: 'horizontal',
      config: {},
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/users/getAll', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.users = res.data.Items.map((user, i) => {
          return {
            ...user,
            key: i,
            email: user.pk.replace('USER#', ''),
          }
        })
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/permissions/groups', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.groups = res.data.Items
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/orgs', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.orgs = res.data.Items
      })
    httpServices.getSims().then((res) => {
      this.sims = res.sort((a, b) => (a.hardwareId > b.hardwareId ? 1 : -1))
    })
    httpServices.getContainers().then((res) => {
      this.containers = res
    })
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (e.target.result.length > 1000000) {
          return alert('Image is loo large.')
        }
        this.image = e.target.result
        this.imageType = file.type
        this.uploadImage()
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.image = ''
      this.imageType = ''
    },
    uploadImage: async function () {
      // Get the presigned URL
      const response = await axios(
        {
          method: 'GET',
          url: `https://futtqyjl69.execute-api.us-east-1.amazonaws.com/dev/uploads?imageType=${this.imageType}`,
        },
        {
          imageType: this.imageType,
        }
      )
      const binary = atob(this.image.split(',')[1])
      const array = []
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      const blobData = new Blob([new Uint8Array(array)], {
        type: this.imageType,
      })
      const result = await fetch(response.data.uploadURL, {
        method: 'PUT',
        body: blobData,
      })
      if (result) {
        // Final URL for the user doesn't need the query string params
        this.uploadURL = response.data.uploadURL.split('?')[0]
      }
    },
    filterContainers(e) {
      this.form.setFieldsValue({ containers: [] })
      const hardwareId = this.sims.filter((s) => s.pk === e)[0].hardwareId
      this.availableContainers = this.containers
        .filter((i) => i.hardwareId === hardwareId)
        .map((j) => j.bonfireId)
        .sort()
    },
    remove(k) {
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      // We need at least one passenger
      if (keys.length === 1) {
        return
      }

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter((key) => key !== k),
      })
    },
    add() {
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      const nextKeys = keys.concat(id++)
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys,
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!values.email_username || !values.email_password || !values.sims) {
          this.$notification.error({
            message: 'Please fill out all required fields',
          })
        } else if (!err) {
          const orgId = this.$auth.user.profile.permissions.organization

          const accounts =
            values?.keys?.map((key) => {
              return {
                platform: values.platform[key],
                platform_dateActivated: values.platform_dateActivated[key],
                platform_dateInactivated: values.platform_dateInactivated[key],
                platform_notes: values.platform_notes[key],
                platform_password: values.platform_password[key],
                platform_status: values.platform_status[key],
                platform_username: values.platform_username[key],
              }
            }) || []

          const data = {
            orgId,
            meta: {
              userId: values.userId || [],
              groupId: values.groupId || [],
              orgId,
              email: {
                username: values.email_username,
                password: values.email_password,
                inactive: values.email_inactive,
                dateActivated: values.email_dateActivated,
                dateInactivated: values.email_dateInactivated,
              },
              sims: values.sims
                ? this.sims.filter((s) => s.pk === values.sims)[0]
                : null,
              bio: {
                firstName: values.firstName,
                lastName: values.lastName,
                dob: values.dob,
                email: values.email_username,
                birthplace: values.birthplace,
                active: values.active,
                currentLocation: values.currentLocation,
                phoneType: values.phoneType,
                profileImage: values.profileImage,
                imageUrl: this.uploadURL,
              },
              containers: values.containers,
              accounts,
            },
          }

          axios
            .post(process.env.VUE_APP_KONSUL_API_URL + '/figments', data, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Figment'
                  } Successfully Created`,
                })
                this.$router.push({
                  name: 'figments',
                })
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Create Figment',
                })
              }
            )
        } else {
          this.$notification.error({
            message: 'Please fill out all required fields',
          })
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/figments">
              <a-icon type="solution" />
              <span>Figments</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="profile" />
            Create Figment
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-figment">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="profile" style="padding-right: 4px" />
            Create Figment
          </h4>
        </div>

        <template>
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Biographical">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="First Name">
                          <a-input
                            v-decorator="[
                              'firstName',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your firstName!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Last Name">
                          <a-input
                            v-decorator="[
                              'lastName',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your lastName!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Current Location">
                          <a-input
                            v-decorator="[
                              'currentLocation',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your current location!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Birthplace">
                          <a-input
                            v-decorator="[
                              'birthplace',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your current birthplace!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Date of Birth">
                          <a-date-picker
                            v-decorator="[
                              'dob',
                              {
                                rules: [
                                  {
                                    type: 'any',
                                    required: true,
                                    placeholder: 'Please input your dob!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="6">
                        <a-form-item label="Is Active">
                          <a-switch
                            v-decorator="[
                              'active',
                              {
                                valuePropName: 'checked',
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="16">
                        <a-form-item label="Profile Image">
                          <div v-if="!image" class="ant-form-item">
                            <input type="file" @change="onFileChange" />
                          </div>
                          <div v-else class="image--container">
                            <img
                              :src="image"
                              style="max-width: 300px; max-height: 300px"
                            />
                            <br /><br />
                            <a-button
                              type="danger"
                              icon="delete"
                              @click="removeImage"
                              >Remove Image</a-button
                            >
                          </div>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="2" tab="Email">
                  <a-card style="width: 100%">
                    <a-col :sm="16" :md="12">
                      <a-form-item label="Email">
                        <a-input
                          v-decorator="[
                            'email_username',
                            {
                              rules: [
                                {
                                  required: true,
                                  placeholder: 'Please input your email!',
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="12">
                      <a-form-item label="Password">
                        <a-input-password
                          v-decorator="[
                            'email_password',
                            {
                              rules: [
                                {
                                  required: true,
                                  placeholder: 'Please input your password!',
                                },
                              ],
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="8">
                      <a-form-item label="Inactive">
                        <a-switch
                          v-decorator="[
                            'email_inactive',
                            {
                              valuePropName: 'status',
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="8">
                      <a-form-item label="Date Activated">
                        <a-date-picker
                          v-decorator="['email_dateActivated', config]"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="8">
                      <a-form-item label="Date Inactivated">
                        <a-date-picker
                          v-decorator="['email_dateInactivated', config]"
                        />
                      </a-form-item>
                    </a-col>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="3" tab="Accounts">
                  <a-card style="width: 100%">
                    <a-form-item
                      v-for="k in form.getFieldValue('keys')"
                      :key="k"
                    >
                      <a-col :sm="16" :md="8">
                        <a-form-item label="Platform">
                          <a-select v-decorator="[`platform[${k}]`]">
                            <a-select-option
                              v-for="(s, i) in socials"
                              :key="i"
                              :value="s.toLowerCase()"
                            >
                              {{ s }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Username">
                          <a-input
                            v-decorator="[
                              `platform_username[${k}]`,
                              {
                                rules: [
                                  {
                                    placeholder: 'Please input your username!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Password">
                          <a-input-password
                            v-decorator="[
                              `platform_password[${k}]`,
                              {
                                rules: [
                                  {
                                    placeholder: 'Please input your password!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Inactive">
                          <a-switch
                            v-decorator="[
                              `platform_status[${k}]`,
                              {
                                valuePropName: 'status',
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Date Activated">
                          <a-date-picker
                            v-decorator="[
                              `platform_dateActivated[${k}]`,
                              config,
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="8">
                        <a-form-item label="Date Inactivated">
                          <a-date-picker
                            v-decorator="[
                              `platform_dateInactivated[${k}]`,
                              config,
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="24">
                        <a-form-item label="Notes">
                          <a-textarea
                            v-decorator="[
                              `platform_notes[${k}]`,
                              {
                                rules: [
                                  {
                                    placeholder: 'Please input your notes!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-popconfirm
                        v-if="form.getFieldValue('keys').length > 1"
                        :disabled="form.getFieldValue('keys').length === 1"
                        title="Sure to delete?"
                        @confirm="() => remove(k)"
                      >
                        <a-icon
                          class="dynamic-delete-button"
                          type="minus-circle-o"
                        />
                      </a-popconfirm>
                    </a-form-item>

                    <a-form-item>
                      <a-button type="dashed" style="width: 100%" @click="add">
                        <a-icon type="plus" /> Add Account
                      </a-button>
                    </a-form-item>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="4" tab="User Permissions">
                  <a-card style="width: 100%">
                    <a-col :sm="16" :md="8">
                      <a-form-item label="groupId">
                        <a-select v-decorator="['groupId']" mode="multiple">
                          <a-select-option
                            v-for="group in groups"
                            :key="group.pk"
                            :value="group.pk"
                          >
                            {{ group.pk.replace('GROUP#', '') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="8">
                      <a-form-item label="userId">
                        <a-select v-decorator="['userId']" mode="multiple">
                          <a-select-option
                            v-for="user in users"
                            :key="user.key"
                            :value="user.email"
                          >
                            {{ user.email }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="5" tab="SMS">
                  <a-card style="width: 100%">
                    <a-col :sm="16" :md="24">
                      <a-form-item label="Select SIM">
                        <a-select
                          v-decorator="[
                            'sims',
                            {
                              rules: [
                                {
                                  required: true,
                                  placeholder: 'Please input your SIM!',
                                },
                              ],
                            },
                          ]"
                          @change="filterContainers"
                        >
                          <a-select-option
                            v-for="(s, i) in sims"
                            :key="s.pk + i"
                            :value="s.pk"
                          >
                            Hardware: {{ s.hardwareId }} - {{ s.pk }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>

                    <a-col v-if="form.getFieldValue('sims')" :sm="16" :md="24">
                      <a-form-item label="Select Containers">
                        <a-select
                          v-decorator="[
                            'containers',
                            {
                              rules: [
                                {
                                  required: true,
                                },
                              ],
                            },
                          ]"
                          mode="multiple"
                        >
                          <a-select-option
                            v-for="(c, i) in availableContainers"
                            :key="i"
                            :value="c"
                          >
                            {{ c }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>

                    <a-col :sm="16" :md="24">
                      <a-form-item label="Phone Type">
                        <a-input v-decorator="['phoneType']" />
                      </a-form-item>
                    </a-col>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button type="primary" html-type="submit">
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
